import React from 'react';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const BusBookingSearchFormContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusBookingSearchResult" */ '../containers/BusBookingSearchFormContainer'),
  loading: DefaultLoadingScreen,
});

const BusBookingSearchFormContainerScreen = props => (
  <BusBookingSearchFormContainer {...props} />
);

export default BusBookingSearchFormContainerScreen;
